(() => {
  const body = document.body;
  if (!body.classList.contains('ce-policy-page')) return;

  const container = document.querySelector('.shopify-policy__container');
  const title = container?.querySelector('.shopify-policy__title');
  const heading = title?.querySelector('h1');
  const policyBody = container?.querySelector('.shopify-policy__body');
  const richText = policyBody?.querySelector('.rte') || policyBody;
  if (!container || !title || !heading || !policyBody || !richText) return;

  const titles = {
    '/policies/refund-policy': 'Política de devoluciones',
    '/policies/shipping-policy': 'Política de envíos',
    '/policies/privacy-policy': 'Política de privacidad',
    '/policies/terms-of-service': 'Términos del servicio',
    '/policies/contact-information': 'Información de contacto'
  };
  const path = window.location.pathname.replace(/\/$/, '');
  if (titles[path]) {
    heading.textContent = titles[path];
    document.title = `${titles[path]} – Compra Express`;
  }

  const eyebrow = document.createElement('span');
  eyebrow.className = 'ce-policy__eyebrow';
  eyebrow.textContent = 'Información clara · Compra Express';
  title.prepend(eyebrow);

  const sections = [...richText.querySelectorAll('h2')];
  if (sections.length) {
    const layout = document.createElement('div');
    layout.className = 'ce-policy__layout';
    const nav = document.createElement('nav');
    nav.className = 'ce-policy__toc';
    nav.setAttribute('aria-label', 'Contenido de la política');
    nav.innerHTML = '<strong>En esta página</strong>';

    sections.forEach((section, index) => {
      const id = `seccion-${index + 1}`;
      section.id = id;
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = section.textContent;
      nav.append(link);
    });

    policyBody.before(layout);
    layout.append(nav, policyBody);

    if ('IntersectionObserver' in window) {
      const links = [...nav.querySelectorAll('a')];
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
        });
      }, { rootMargin: '-20% 0px -68% 0px', threshold: 0 });
      sections.forEach((section) => observer.observe(section));
    }
  }

  requestAnimationFrame(() => body.classList.add('ce-page-ready'));
})();
